@if (userInfoApi?.id) {
  <div class="home-wrapper d-flex flex-column align-items-center">
    @if (!isLoading) {
      <div class="home-wrapper__box d-flex flex-column">
        <div class="d-flex justify-content-center">
          <img src="../../assets/img/logo-medispring-vertical.svg" width="150vw" height="150vh" alt="Medispring logo displayed vertically" />
        </div>
        <div>
          <div class="classic">
            <div class="userInfo">Bienvenue sur le cockpit {{userInfoApi?.given_name}} {{userInfoApi?.family_name}}</div>
          </div>
        </div>
        @if (accessRight?.rights?.length) {
          <div class="buttons">
            @for (right of accessRight?.rights; track right?.version) {
              <button mat-flat-button color="primary" class="mr10" (click)="login(right?.version)">Version {{right?.version}}</button>
            }
          </div>
        }
      </div>
    }
    @if (isLoading) {
      <div>
        <div class="textaligncenter mb10">
          <mat-progress-spinner class="spinner"></mat-progress-spinner>
        </div>
      </div>
    }
  </div>
}


